import experimentFlags, { SHOP_HOLIDAYS_2022 } from 'util/experimentFlags';
import giftNavIcon from 'assets/images/navigation/gift.svg';
import registryAccountLinks from '../../data/registryAccountLinks';

class SecondaryNavRegistryData {
  constructor(userContext, registryCategoryItems) {
    this.userContext = userContext;

    if (
      registryCategoryItems &&
      registryCategoryItems.categories &&
      registryCategoryItems.categories.length > 0
    ) {
      this.categories = registryCategoryItems.categories;
    } else {
      this.categories = [];
    }

    if (
      registryCategoryItems &&
      registryCategoryItems.brands &&
      registryCategoryItems.brands.length > 0
    ) {
      this.brands = registryCategoryItems.brands;
    } else {
      this.brands = [];
    }
  }

  getItems() {
    if (this.categories == null) {
      return [];
    }
    const currentPath = window.location.pathname;
    const cashFundsItem = {
      identifier: 'cash-funds',
      text: 'Cash Funds',
      path: '/shop/honeymoon-cash-funds',
    };

    Object.assign(cashFundsItem, {
      showCaret: false,
      dockRight: true,
      centerDropdown: false,
      dropdownItems: [
        {
          identifier: 'honeymoon-cash-funds',
          text: 'Cash & Honeymoon Funds',
          path: '/shop/honeymoon-cash-funds',
        },
        {
          identifier: 'gift-cards',
          text: 'Gift Cards',
          path: '/shop/category/gift-cards',
        },
      ],
    });

    let items = this.navItems().concat(
      this.createSubCategory(this.categories).concat(cashFundsItem)
    );
    // If user does not have a registry remove registry tab
    if (!this.userContext.has_registry) {
      items = items.slice(1);
    }
    items = this.setActiveItem(items, currentPath);

    return items;
  }

  setActiveItem(items, currentPath) {
    return items.map((item) => {
      const currentItem = item;
      currentItem.isActive = currentPath.indexOf(currentItem.path) > -1;
      return currentItem;
    });
  }

  createSubCategory(categories) {
    return categories.map((category) => {
      const isNewExperiencesItem = category.path === '/shop/category/experiences';
      const categoryItem = {
        identifier: category.path,
        text: category.title,
        path: category.path,
        showCaret: false,
        dropdownItems: category.children,
        centerDropdown: !isNewExperiencesItem,
        dockRight: isNewExperiencesItem,
      };
      return categoryItem;
    });
  }

  createBrandsDropdownItems(brands) {
    const featuredBrands = brands.slice(0, 7);
    const featuredBrandsItems = featuredBrands.map((featureBrand) => ({
      text: featureBrand.title,
      path: featureBrand.path,
    }));
    featuredBrandsItems.push({ text: 'View All', path: '/shop/brands' });
    return [
      { text: 'Featured Brands', path: '/shop/brands', children: featuredBrandsItems },
      { text: 'Partner Stores', path: '/shop/brands', children: this.partnerStoreItems() },
    ];
  }

  navItems() {
    return [
      {
        identifier: 'your-registry',
        text: 'Your Registry',
        path: '/registry/overview',
        target: '_self',
        dropdownItems: this.registryItems(),
        showCaret: true,
      },
      {
        identifier: 'new-arrivals',
        text: 'New Arrivals',
        path: '/shop/collection/new-arrivals',
      },
      {
        identifier: 'collections',
        text: 'Collections',
        path: '/shop/gift-collections/starter-collections',
        dropdownItems: this.starterCollectionItems(),
        showCaret: false,
        icon: experimentFlags.getFlag(SHOP_HOLIDAYS_2022, this.userContext)
          ? giftNavIcon
          : undefined,
      },
      {
        identifier: 'brands',
        text: 'Brands',
        path: '/shop/brands',
        target: '_self',
        dropdownItems: this.createBrandsDropdownItems(this.brands),
        showCaret: false,
      },
    ];
  }

  partnerStoreItems() {
    return [
      { text: 'Crate and Barrel', path: '/shop/partner-boutique/crate-barrel' },
      { text: "Macy's", path: '/shop/partner-boutique/macys', badgeText: 'new' },
      { text: 'Backcountry', path: '/shop/partner-boutique/backcountry' },
    ];
  }

  starterCollectionItems() {
    const navItem = [
      { text: 'Most Popular Gifts', path: '/shop/collection/top-registry-gifts-this-week' },
      { text: 'Registry Essentials', path: '/shop/collection/zola-registry-essentials' },
      { text: 'Ultimate Kitchen Essentials', path: '/shop/collection/top-kitchen-essentials' },
      { text: 'Entertaining Must-Haves', path: '/shop/collection/easy-entertaining' },
      { text: 'Build Your Bar', path: '/shop/collection/build-your-bar' },
      { text: 'Gifts Guests Love to Give', path: '/shop/collection/guests-favorites' },
      { text: 'Gifts Under $100', path: '/shop/collection/gifts-under-100' },
    ];

    return navItem;
  }

  registryItems() {
    return registryAccountLinks(this.userContext);
  }
}

export default SecondaryNavRegistryData;
